import './assets/index.css'
import '@gohighlevel/ghl-ui/dist/style.css'
import '@iconify/iconify'

import mitt from 'mitt'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createMetaManager } from 'vue-meta'
import App from './App.vue'
import i18n from './locales'
import router from './router/'

const app = createApp(App).use(createMetaManager())

app.use(createPinia())
app.use(i18n)

const emitter = mitt()
app.config.globalProperties.emitter = emitter

app.use(router)
app.mount('#app')
